import { TrashSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { usePartFinderProductTypeActions } from 'companySettings/hooks';
import { IPartFinderProductType } from 'companySettings/types';
import { Button, Confirmation } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Removing is never blocked; the warning says what happens to the families on the type (869f8wxx1).
export const RemovePartFinderProductTypesButton = () => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, updateRows } = useAgGridClientTableContext();
  const { removePartFinderProductTypes } = usePartFinderProductTypeActions(
    NotificationPosition.TOP
  );

  const productTypes = (selectedRows ?? []) as IPartFinderProductType[];

  const onRemove = async () => {
    setIsConfirmationOpen(false);

    const { success } = await removePartFinderProductTypes(
      productTypes.map((productType) => productType.id)
    );

    if (!success) {
      return;
    }

    updateRows({ remove: productTypes });
  };

  return (
    <>
      <Button
        text={t('buttonLabelRemove')}
        variant={Variant.SOFT}
        color={Color.DANGER}
        startDecorator={<TrashSimple />}
        onClick={() => setIsConfirmationOpen(true)}
      />

      <Confirmation
        isOpen={isConfirmationOpen}
        color={Color.WARNING}
        title={t('titleRemovePartFinderProductTypes', { count: productTypes.length })}
        message={t('messageConfirmRemovePartFinderProductTypes', {
          count: productTypes.length,
          name: productTypes[0]?.name,
        })}
        confirmBtnLabel={t('buttonLabelRemove')}
        confirmBtnColor={Color.DANGER}
        onConfirm={onRemove}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
